import React from 'react'
import { updateRendezVous } from '../../store/slices/rendezVousSlice';
import { fetchCalendarData, fetchDemandesRendezvous } from '../../store/slices/rendezVousPrestaSlice';
import { toast } from "react-toastify";

export const RefusRdv = async ({ dispatch, rendezVous, handleClose, setPopupVisible }) =>  {
//  console.log("rendezVous++++++++++++",rendezVous)
    try {
    const updatedRdv = {
      id: rendezVous.id,
      status: "annule",
    };

    await dispatch(updateRendezVous(updatedRdv)).unwrap();
    await dispatch(fetchCalendarData());

    toast.success("Rendez-vous refusé avec succès");
    
    if (setPopupVisible) setPopupVisible(false);
    if (handleClose) handleClose();
  } catch (error) {
    // console.error("Erreur lors de l'annulation :", error);
    toast.error("Échec de l'annulation du rendez-vous");
  }
};
